export default __webpack_public_path__ + "static/media/alejandro-loguercio-orchester.28f4ecd9.png";